import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c223c83")

_pushScopeId("data-v-2c223c83")
const _hoisted_1 = { class: "esd-logo" }
const _hoisted_2 = { ref: "esdLogo" }
const _hoisted_3 = { class: "text-div" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", null, "Your session has been renewed.", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, null, 512)
    ]),
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeWindow && _ctx.closeWindow(...args))),
        "data-auto-analytics": "click",
        "data-workflow-id": "renew-session",
        "data-sub-workflow-id": "close-renew-session"
      }, "Close Tab")
    ])
  ]))
})